(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-by-market"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.getElementById('currency-by-market-config');

    if (!configElement) return;

    let config;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      return;
    }

    if (!config.code || !config.rate) return;

    const MONEY_SOURCE = String.raw`(\d[\d,]*(?:\.\d+)?)\s*(?:BHD\b|BD\b|د\.ب\.?)`;
    const SKIPPED_TAGS = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'NOSCRIPT']);
    const STEP = 0.05;

    const formatter = new Intl.NumberFormat(`${config.lang || 'en'}-u-nu-latn`, {
      style: 'currency',
      currency: config.code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const convert = (text) =>
      text.replace(new RegExp(MONEY_SOURCE, 'g'), (match, amount) => {
        const value = Number(amount.replace(/,/g, ''));

        if (!Number.isFinite(value)) return match;

        return formatter.format(Math.round((value * config.rate) / STEP) * STEP);
      });

    const isConvertible = (node) => {
      const parent = node.parentElement;

      if (!parent) return false;
      if (SKIPPED_TAGS.has(parent.tagName)) return false;
      if (parent.closest('[data-currency-skip], [data-lp-no-convert]')) return false;

      return new RegExp(MONEY_SOURCE).test(node.nodeValue);
    };

    let converting = false;

    const convertTree = (root) => {
      if (converting) return;

      converting = true;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => (isConvertible(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT)
      });
      const targets = [];

      while (walker.nextNode()) targets.push(walker.currentNode);

      for (const node of targets) node.nodeValue = convert(node.nodeValue);

      converting = false;
    };

    let frame = 0;

    const scheduleConversion = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => convertTree(document.body));
    };

    const start = () => {
      convertTree(document.body);
      new MutationObserver(scheduleConversion).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
